export { Chip } from "@mantine/core";
export type { ChipProps, ChipGroupProps } from "@mantine/core";
export { getChipOverrides } from "./Chip.styled";
